<template>
    <div class="error-bar"><strong>Fout:</strong> {{ errorMessage }}</div>
</template>
<script>
export default {
    props: {
        errorMessage: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.error-bar {
    background-color: red;
    color: white;
    min-height: 50px;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    text-align: center;
    line-height: 50px;
    z-index: 1;
}
</style>
